




















import { defineComponent, computed } from '@vue/composition-api';
import Vue from 'vue';
import { useIframe } from './hooks';
import props from './props';

const name = 'ttam-creative-iframe-drawer';
export default defineComponent({
  name,
  props,
  setup(_props, ctx) {
    const isRtl = computed(() => _props.isRtl);
    const _drawerTop = computed(() => _props.drawerTop ?? `${Vue.prototype.$TTAMUI?.headerHeight}px`);

    return {
      slideTransition: computed(() => (isRtl.value ? 'slide-left' : 'slide-right')),
      _drawerTop,
      ...useIframe(_props, ctx),
    };
  },
});
